<div class="content">
  <div class="content-panel">
    <div class="searchBar">
      <label class="form-label" for="searchBar-input" translate>page.admin.utilisateur.liste.table.filtrer</label>
      <input type="text" id="searchBar-input" (ngModelChange)="searchStringUpdate.next($event)" [(ngModel)]="searchStringInput"
        placeholder="{{'label.filtre'|translate}}">
    </div>
    <table *ngIf="droits" class="table table-striped" aria-label="Tableau des droits">
      <thead>
        <tr>
          <th scope="col" (click)="setOrder('__defaultOrder')" (keydown.enter)="setOrder('__defaultOrder')" class="sortable">
            {{ 'Email' | translate }}
            <fa-icon [icon]="getIcon('__defaultOrder')"></fa-icon>
          </th>
          <th scope="col" (click)="setOrder('profil.type.code')" (keydown.enter)="setOrder('profil.type.code')" class="sortable">
            {{ 'Type' | translate }}
            <fa-icon [icon]="getIcon('profil.type.code')"></fa-icon>
          </th>
          <th scope="col" (click)="setOrder('profil.domaine.libelle')" (keydown.enter)="setOrder('profil.domaine.libelle')" class="sortable">
            {{ 'Domaine' | translate }}
            <fa-icon [icon]="getIcon('profil.domaine.libelle')"></fa-icon>
          </th>
          <th scope="col" (click)="setOrder('profil.service.libelleCourt')" (keydown.enter)="setOrder('profil.service.libelleCourt')" class="sortable">
            {{ 'Service' | translate }}
            <fa-icon [icon]="getIcon('profil.service.libelleCourt')"></fa-icon>
          </th>
          <th scope="col" (click)="setOrder('profil.organisme.raisonSociale')" (keydown.enter)="setOrder('profil.organisme.raisonSociale')" class="sortable">
            {{ 'Organisme' | translate }}
            <fa-icon [icon]="getIcon('profil.organisme.raisonSociale')"></fa-icon>
          </th>
          <th scope="col" (click)="setOrder('profil.profil.libelle')" (keydown.enter)="setOrder('profil.profil.libelle')" class="sortable">
            {{ 'Profil' | translate }}
            <fa-icon [icon]="getIcon('profil.profil.libelle')"></fa-icon>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let droit of droits | filter : '*': searchString | orderBy:order.property:order.reverse:true; let idx = index;">
          <tr >
            <td [ngClass]="{'inactif':droit.profil.intervenant?.actif === false}">{{droit.profil.intervenant?.mail}}</td>
            <td [ngClass]="{'inactif':droit.profil.type?.actif === false}">{{droit.profil.type?.code}}</td>
            <td [ngClass]="{'inactif':droit.profil.domaine?.actif === false}">{{droit.profil.domaine?.libelle}}</td>
            <td>{{droit.profil.service?.libelleCourt}}</td>
            <td [ngClass]="{'inactif':droit.profil.organisme?.actif === false}">{{droit.profil.organisme?.raisonSociale}}</td>
            <td [ngClass]="{'inactif':droit.profil.profil?.actif === false}">{{droit.profil.profil?.libelle}}</td>
          </tr>
          <tr>
            <td colspan="6" class="liste-roles">
              <div>
                <fa-icon *ngIf="!droit.display_data" icon="plus" (click)="droit.display_data = true;"></fa-icon>
                <fa-icon *ngIf="droit.display_data" icon="minus" (click)="droit.display_data = false;"></fa-icon>
                Données
              </div>
              <pre *ngIf="droit.display_data" class="columns">{{droit.profil | json}}</pre>
              <div>
                <fa-icon *ngIf="!droit.display_roles" icon="plus" (click)="droit.display_roles = true;"></fa-icon>
                <fa-icon *ngIf="droit.display_roles" icon="minus" (click)="droit.display_roles = false;"></fa-icon>
                Droits fonctionnels et roles
              </div>
              <ul *ngIf="droit.display_roles" class="columns">
                <li *ngFor="let fct of droit.fonctionnels" class="columns-nobreak" [title]="fct.id+' - '+fct.code">
                  {{fct.libelle}}
                  <ul>
                    <li *ngFor="let role of fct.roles" [title]="role.id+' - '+role.code">{{role.libelle}}</li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
